import { Spinner } from "react-bootstrap"
import i18next from "i18next"
import _ from 'lodash';

const LoadingOverlay = ({ show, message }) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        visibility: show ? 'visible' : 'hidden',
      }}
    >
      <div className="d-flex gap-4 align-items-center">
        <Spinner animation="border" role="status" variant="info">
          <span className="visually-hidden">{message || i18next.t('loading')}</span>
        </Spinner>
        <div>{message || i18next.t('loading')}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
